import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js"

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    this.#load()
  }

  async #load() {
    try {
      const res = await get(`${this.urlValue}?is_being_loaded_action=true`, { responseKind: "turbo-stream" })
      console.log(this.urlValue)

      if (!res.ok) {
        console.error(`Failed to load content: ${res.status} ${res.statusText}`)
        console.error(`URL: ${this.urlValue}`)
        // Optionally handle specific error cases
        if (res.status === 404) {
          console.error("Content not found")
        } else if (res.status >= 500) {
          console.error("Server error occurred")
        }
        return
      }

      console.log("Content loaded successfully")
    } catch (error) {
      console.error("Network error or request failed:", error)
    }
  }
}
